export enum NotificationPermissionState {
    DEFAULT = "default",    //CT support
    GRANTED = "granted",    //CT support
    DENIED = "denied",      //CT support
    VISIBLE = "visible"     //FCM support
}
